import { InteractionHandler } from "../Interactions";
import { convertToNumber3, FlyToHitpointAction } from "flavr-common";
import { Vector3 } from "flavr-math";
import { FlyToDestinationMessage } from "../../../messages/locomotion/LocomotionMessages";
const tmpTargetPosition = new Vector3();
const tmpContextPosition = new Vector3();
export class FlyToHitpointInteractionHandler extends InteractionHandler {
    constructor() {
        super(FlyToHitpointAction.typestatic, [], [FlyToHitpointAction.typestatic], []);
    }
    getActionDescription() {
        return "Zum Zielpunk fliegen";
    }
    performAction(action, context) {
        if (FlyToHitpointAction.is(action) && context.position) {
            const targetPos = tmpTargetPosition.fromArray(action.offset).add(tmpContextPosition.fromArray(context.position));
            this.connection.send(new FlyToDestinationMessage(convertToNumber3(targetPos), {
                velocity: action.velocity
            }));
        }
    }
}
